(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["block-about-1"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const elements = document.querySelectorAll('.about-top-image-1, .about-top-image-2, .about-top-image-3, .about-top-image-4, .about-top-image-5');

    if (!elements.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '0px 0px -10% 0px'
    });

    elements.forEach(el => observer.observe(el));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["block-about-2"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const elements = document.querySelectorAll('.about-bottom-image-1, .about-bottom-image-2, .about-bottom-image-3, .about-bottom-image-4');

    if (!elements.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '0px 0px -10% 0px'
    });

    elements.forEach(el => observer.observe(el));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["block-comparison-wildkitchen"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
    // Row hover
    const rows = document.querySelectorAll('[data-row]');

    rows.forEach(row => {
        row.addEventListener('mouseenter', function() {
            const rowNumber = this.getAttribute('data-row');
            const matchingRows = document.querySelectorAll(`[data-row="${rowNumber}"]`);
            
            matchingRows.forEach(matchingRow => {
                matchingRow.classList.add('active');
            });
        });
        
        row.addEventListener('mouseleave', function() {
            const rowNumber = this.getAttribute('data-row');
            const matchingRows = document.querySelectorAll(`[data-row="${rowNumber}"]`);
            
            matchingRows.forEach(matchingRow => {
                matchingRow.classList.remove('active');
            });
        });
    });

    // Mobile Select change
    const selects = document.querySelectorAll('select[data-redirect-select]');

    selects.forEach(select => {
      select.addEventListener('change', function () {
        const url = this.value;
        if (url) {
          window.location.href = url;
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["block-comparison-wildtable"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
    // Row hover
    const rows = document.querySelectorAll('[data-row]');

    rows.forEach(row => {
        row.addEventListener('mouseenter', function() {
            const rowNumber = this.getAttribute('data-row');
            const matchingRows = document.querySelectorAll(`[data-row="${rowNumber}"]`);
            
            matchingRows.forEach(matchingRow => {
                matchingRow.classList.add('active');
            });
        });
        
        row.addEventListener('mouseleave', function() {
            const rowNumber = this.getAttribute('data-row');
            const matchingRows = document.querySelectorAll(`[data-row="${rowNumber}"]`);
            
            matchingRows.forEach(matchingRow => {
                matchingRow.classList.remove('active');
            });
        });
    });

    // Mobile Select change
    const selects = document.querySelectorAll('select[data-redirect-select]');

    selects.forEach(select => {
      select.addEventListener('change', function () {
        const url = this.value;
        if (url) {
          window.location.href = url;
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["block-faq-single"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".accordion-item").forEach((item) => {
      const title = item.querySelector(".accordion-title");

      title.addEventListener("click", () => {
        item.classList.toggle("open");
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["block-header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.header.classList.add('!z-[998]');
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      this.currentScrollTop = 0;
      this.lastScrollTop = 0;

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const isScrollingDown = scrollTop > this.lastScrollTop;

      if (isScrollingDown && scrollTop > 50) {
        this.classList.add('scrolled');
      } else if (!isScrollingDown) {
        this.classList.remove('scrolled');
      }

      this.lastScrollTop = scrollTop;
    }

  }
  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('DOMContentLoaded', () => {
    // Menu Open/Close
    const btn = document.getElementById('menuBtn');
    const closeBtn = document.getElementById('closeMenu');
    const mobileBtn = document.getElementById('mobileBtn');
    const target = document.getElementById('megaMenu');

    btn.addEventListener('click', () => {
      target.classList.toggle('active');
    });
    
    closeBtn.addEventListener('click', () => {
      target.classList.remove('active');
    });

    mobileBtn.addEventListener('click', () => {
      target.classList.toggle('active');
    });

    // Menu Link Hover
    const items = document.querySelectorAll('[data-target]');
    items.forEach(item => {
      item.addEventListener('mouseenter', () => {
        const target = item.getAttribute('data-target');

        // Remove active from all
        document.querySelectorAll('[class*="image-"]').forEach(el => el.classList.remove('active'));
        document.querySelectorAll('[class*="description-"]').forEach(el => el.classList.remove('active'));

        // Add active to matching ones
        const img = document.querySelector(`.image-${target}`);
        const desc = document.querySelector(`.description-${target}`);

        if (img) img.classList.add('active');
        if (desc) desc.classList.add('active');
      });

      item.addEventListener('mouseleave', () => {
        // Optional: remove active when no longer hovering
        document.querySelectorAll('[class*="image-"]').forEach(el => el.classList.remove('active'));
        document.querySelectorAll('[class*="description-"]').forEach(el => el.classList.remove('active'));
      });
    });

    // Search Open/Close
    const searchBtn = document.getElementById('searchOpen');
    const searchBox = document.getElementById('searchBox');
    const searchClose = document.getElementById('searchBoxClose');
    
    searchBtn.addEventListener('click', () => {
      searchBox.classList.remove('hidden');
    });
    searchClose.addEventListener('click', () => {
      searchBox.classList.add('hidden');
    });
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["block-hero-home"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const logo = document.querySelector('.logo');
    
    if (logo) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.intersectionRatio >= 0.6) {
            logo.classList.add('visible');
          }
        });
      }, {
        threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1]
      });
      
      observer.observe(logo);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["block-home-intro"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const elements = document.querySelectorAll('.top-copy, .top-image, .left-image, .right-image, .bottom-media');

    if (!elements.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '0px 0px -10% 0px'
    });

    elements.forEach(el => observer.observe(el));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["block-main-product-promo"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const promoElement = document.querySelector('.main-product-promo');
    if (promoElement) {
      const header = promoElement.parentElement;
      if (header) {
        header.classList.add('!z-[999]');
      }
    }

    // Scroll animation functionality
    const promoBlocks = document.querySelectorAll('.promo-block');
    
    function updatePromoBlocks() {
      promoBlocks.forEach((block, index) => {
        const blockIndex = parseInt(block.dataset.blockIndex);
        
        // Don't animate the last block
        if (index === promoBlocks.length - 1) return;
        
        // Get the next block
        const nextBlock = promoBlocks[index + 1];
        if (!nextBlock) return;
        
        const nextBlockIndex = parseInt(nextBlock.dataset.blockIndex);
        
        // Determine the sticky position for the next block
        let nextStickyTop = 0;
        if (nextBlockIndex === 2) nextStickyTop = 60;
        if (nextBlockIndex === 3) nextStickyTop = 120;
        
        // Get position of next block
        const nextRect = nextBlock.getBoundingClientRect();
        
        // Calculate scroll progress based on next block's approach to its sticky position
        // Animation starts when next block is 300px above its sticky position
        // Animation completes when next block reaches its sticky position
        const animationRange = 500;
        const distanceToSticky = nextRect.top - nextStickyTop;
        const scrollProgress = Math.max(0, Math.min(1, 1 - (distanceToSticky / animationRange)));
        
        // Get elements of current block
        const image = block.querySelector('.promo-image');
        const heading = block.querySelector('.promo-heading');
        const content = block.querySelector('.promo-content');
        
        if (image && heading && content) {
          // Parallax effect: move image and content upward as scroll progresses and fade out
          const maxTranslate = 800; // Maximum pixels to move up
          const currentTranslate = scrollProgress * maxTranslate;
          // image.style.transform = `translateY(-${currentTranslate}px)`;
          // content.style.transform = `translateY(-${currentTranslate}px)`;
          image.style.opacity = 1 - (scrollProgress * 2);
          content.style.opacity = 1 - (scrollProgress * 2);
          
          // Move heading up from center (25%) to 0% from top
          const blockHeight = block.offsetHeight;
          const startPosition = 25;
          const endPosition = 0;
          const currentPosition = startPosition - (scrollProgress * (startPosition - endPosition));
          heading.style.top = `${currentPosition}%`;

          // Animate heading size (px)
          const startFontSize = 88;
          const endFontSize = 60;
          const currentFontSize = startFontSize - (scrollProgress * (startFontSize - endFontSize));
          heading.style.fontSize = `${currentFontSize}px`;

          // Animate padding top (rem)
          const startPadding = 3;
          const endPadding = 1.75;
          const currentPadding = startPadding - (scrollProgress * (startPadding - endPadding));

          block.style.paddingTop = `${currentPadding}rem`;
        }
      });
    }
    
    if (window.matchMedia("(min-width: 768px)").matches) {
      // Initial call
      updatePromoBlocks();
      
      // Update on scroll with throttling for performance
      let ticking = false;
      window.addEventListener('scroll', () => {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            updatePromoBlocks();
            ticking = false;
          });
          ticking = true;
        }
      });
    };
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["block-video"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
    const modalOpen = document.querySelector('#modalOpen');
    const modalEl = document.querySelector('#modal');
    const modalClose = document.querySelector('#modalClose');
    if (modalEl) {
      modalOpen.addEventListener("click", () => {
        modalEl.classList.add("active");
      });
      modalClose.addEventListener("click", () => {
        modalEl.classList.remove("active");
        const youtubeIframe = modalEl.querySelector('.js-youtube');
        const vimeoIframe = modalEl.querySelector('.js-vimeo');
        if (youtubeIframe) {
          youtubeIframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        }
        if (vimeoIframe) {
          vimeoIframe.contentWindow.postMessage('{"method":"pause"}', '*');
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.header.classList.add('!z-[998]');
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      this.currentScrollTop = 0;
      this.lastScrollTop = 0;

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const isScrollingDown = scrollTop > this.lastScrollTop;

      if (isScrollingDown && scrollTop > 50) {
        this.classList.add('scrolled');
      } else if (!isScrollingDown) {
        this.classList.remove('scrolled');
      }

      this.lastScrollTop = scrollTop;
    }

  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
